define(function () {
    function RecentProducts() {
        var privates = {};
        var publics = {};
        var events = {};
        var storageName = 'recentProducts';
        const daysToLive = 14;
        const secondsToLive = 60 * 60 * 24 * daysToLive;

        publics.module = '';
        publics.products = [];

        privates.init = function () {
            privates.loadFromRaptor();
        };

        privates.loadFromRaptor = function () {
            const fetchUrl = `${window.location.origin}/search/visited/history/1.json`;
            fetch(fetchUrl)
                .then((rawResponse) => {
                    if (!rawResponse.ok) {
                        throw new Error('Raptor response was not OK');
                    } else {
                        return rawResponse.json();
                    }
                })
                .then((response) => {
                    if (response.hits <= 0) {
                        privates.loadFromCache();
                    } else {
                        publics.products = response.products.productBoxes;
                        publics.module = response.module;
                    }
                })
                .catch((error) => {
                    partyking.common.log.error('Error while getting recent product data from Raptor', error);
                    privates.loadFromCache();
                })
                .finally(() => {
                    partyking.common.trigger('recentProductsLoaded', {
                        products: publics.products,
                        module: publics.module,
                    });
                });
        };

        privates.loadFromCache = function () {
            if (_.isObject(partyking.common.models.pkStorage.get(storageName))) {
                var cache = partyking.common.models.pkStorage.get(storageName);
                publics.products = _.isArray(cache.products) ? cache.products : [];
                publics.module = '';

                return true;
            }

            return false;
        };

        publics.update = function () {
            publics.save();
        };

        publics.save = function () {
            partyking.common.models.pkStorage.set(
                storageName,
                {
                    products: publics.products,
                },
                secondsToLive
            );
        };

        publics.addProduct = function (product) {
            privates.removeProduct(product);
            publics.products.unshift(product);
            publics.update();
        };

        privates.findProduct = function (product) {
            var output = _.find(publics.products, function (value) {
                return product.id == value.id;
            });

            return output;
        };

        privates.removeProduct = function (product) {
            publics.products = _.filter(publics.products, function (value) {
                return product.id != value.id;
            });
        };

        privates.init();

        return publics;
    }

    return RecentProducts;
});
